import { render, staticRenderFns } from "./PatientHistory.vue?vue&type=template&id=788837c0&scoped=true"
import script from "./PatientHistory.vue?vue&type=script&lang=js"
export * from "./PatientHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788837c0",
  null
  
)

export default component.exports